module.exports = __webpack_public_path__ + "static/media/shipBgButtonPic.d9834f5d.jpeg";